module.exports = __webpack_public_path__ + "img/photo4.6a11b654.jpg";